<template>
  <div>
    <!-- 面包屑 -->
    <bread-crumb path='内容管理' subPath='ghost文章列表'></bread-crumb>
    <!-- 主体列表 -->
    <el-card>
      <el-row :gutter="20">
        <el-col :span="7">
          <el-input placeholder="请输入标题" v-model="param.keyword" clearable @clear="search">
            <el-button slot="append" icon="el-icon-search" @click="search"></el-button>
          </el-input>
        </el-col>
      </el-row>
    </el-card>
   <el-table :data="list" stripe border :cell-style="{ textAlign: 'center' }">
      <el-table-column prop="id" label="ID" align="center" width="300px"></el-table-column>
      <el-table-column label="标题" align="center" width="270px">
        <template slot-scope="scope">
          <a :href="baseUrl + '/' + scope.row.slug" target="_blank">{{scope.row.title}}</a>
        </template>
      </el-table-column>
      <el-table-column prop="send_num" label="发送" align="center"></el-table-column>
      <el-table-column prop="read_num" label="已读" align="center"></el-table-column>
      <el-table-column prop="read_rate" label="已读率" align="center"></el-table-column>
      <el-table-column prop="published_at" label="发布时间" align="center"></el-table-column>
      <el-table-column prop="created_at" label="创建时间" align="center"></el-table-column>
      <el-table-column label="操作" align="center" width="300px">
        <template slot-scope="scope">
          <el-button type="primary" size="small" @click="showSendDialog(scope.row.id)">发送邮件</el-button>
          <el-button type="success" size="small" @click="showSendLogDialog(scope.row.id)">发送列表</el-button>
        </template>
      </el-table-column>
    </el-table>
   <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="param.page"
      :page-sizes="[10, 20, 30, 40, 50]"
      :page-size="param.count"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total">
    </el-pagination>
    <send-mail :visible="sendDialogAvaible"
      :id="currentId"
      :labelList="labelList"
      :mailgunList="mailgunList"
      @closeDialog="closeSendDialog">
    </send-mail>
    <send-log :visible="sendLogDialogAvaible"
      :id="currentId"
      @closeLogDialog="closeSendLogDialog">
    </send-log>
  </div>
</template>

<script>
import BreadCrumb from '../BreadCrumb.vue'
import SendMail from './SendMail.vue'
import SendLog from './SendLog.vue'
export default {
  name: 'ghost_post_list',
  components: {
    'bread-crumb': BreadCrumb,
    'send-mail': SendMail,
    'send-log': SendLog
  },
  created () {
    this.getList()
    this.getLabelList()
    this.getMailgunList()
  },
  data () {
    return {
      list: [],
      baseUrl: '',
      total: 0,
      pageTotal: 1,
      param: {
        keyword: '',
        page: 1,
        count: 10
      },
      currentId: 0,
      labelList: [],
      mailgunList: [],
      sendDialogAvaible: false,
      sendLogDialogAvaible: false
    }
  },
  methods: {
    async getList () {
      const res = await this.$http.get('/admin/ghost_post/list', this.param)
      if (res.code === 0) {
        this.list = res.data.list
        this.total = res.data.total
        this.pageTotal = res.data.total_page
        this.baseUrl = res.data.base_url
      } else {
        this.$message.error(res.msg)
      }
    },
    async getLabelList () {
      const res = await this.$http.get('/admin/label/select_list')
      if (res.code === 0) {
        this.labelList = res.data
      } else {
        this.$message.error(res.msg)
      }
    },
    async getMailgunList () {
      const res = await this.$http.get('/admin/mailgun/select_list')
      if (res.code === 0) {
        this.mailgunList = res.data
      } else {
        this.$message.error(res.msg)
      }
    },
    search () {
      this.param.page = 1
      this.getList()
    },
    handleSizeChange (size) {
      this.param.count = size
      this.getList()
    },
    handleCurrentChange (page) {
      this.param.page = page
      this.getList()
    },
    showSendDialog (id) {
      this.currentId = id
      this.sendDialogAvaible = true
    },
    closeSendDialog () {
      this.currentId = 0
      this.sendDialogAvaible = false
    },
    showSendLogDialog (id) {
      this.currentId = id
      this.sendLogDialogAvaible = true
    },
    closeSendLogDialog () {
      this.currentId = 0
      this.sendLogDialogAvaible = false
    }
  }
}
</script>

<style scoped>
.list_img {
  width: 50px;
}
</style>
